// import './src/styles/less/global-style.less';
// import './src/styles/styles.css";

import './output.css';

// https://www.gatsbyjs.com/plugins/gatsby-background-image-preact/?=background#important
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`);
    // console.log(`# IntersectionObserver is polyfilled!`);
  }
};
